import { Validator } from "../../../packages/validator/validator.js";

export const validatePath: Validator<string> = (path: unknown) => {
  if (typeof path !== "string") {
    throw new Error("The value is not a string.");
  }

  if (path.includes("..")) {
    throw new Error('Invalid path. ".." is not allowed.');
  }

  const match = path.match(/^[A-Za-z0-9_\-./\s[\]]+$/);
  if (!match) {
    throw new Error('Path contains invalid characters (use A-Z, a-z, 0-9, "_", "-", ".", "/").');
  }

  return path;
};
